module.exports = __webpack_public_path__ + "static/media/ah-iPhone.971632ec.png";